<template>
  <div :class="['multi-input', { 'three-multi': item.controlType === 13 }]">
    <template v-if="[11, 12].includes(item.controlType)">
      <el-input-number
        class="input-number"
        width="46%"
        :value="value.one"
        @change="v => handleChange('one', v)"
        controls-position="right"
        :min="item.minValue === '' ? -Infinity : Number(item.minValue)"
        :max="item.maxValue === '' ? Infinity : Number(item.maxValue)"
      >
      </el-input-number>
      <span>{{ item.controlType === 11 ? '-' : 'x' }}</span>
      <el-input-number
        class="input-number"
        width="46%"
        :value="value.two"
        @change="v => handleChange('two', v)"
        controls-position="right"
        :min="item.minValue === '' ? -Infinity : Number(item.minValue)"
        :max="item.maxValue === '' ? Infinity : Number(item.maxValue)"
      >
      </el-input-number>
    </template>
    <template v-else>
      <el-input-number
        class="input-number"
        width="30%"
        :value="value.one"
        @change="v => handleChange('one', v)"
        controls-position="right"
        :min="item.minValue === '' ? -Infinity : Number(item.minValue)"
        :max="item.maxValue === '' ? Infinity : Number(item.maxValue)"
      >
      </el-input-number>
      <span>x</span>
      <el-input-number
        class="input-number"
        width="30%"
        :value="value.two"
        @change="v => handleChange('two', v)"
        controls-position="right"
        :min="item.minValue === '' ? -Infinity : Number(item.minValue)"
        :max="item.maxValue === '' ? Infinity : Number(item.maxValue)"
      >
      </el-input-number>
      <span>x</span>
      <el-input-number
        class="input-number"
        width="30%"
        :value="value.three"
        @change="v => handleChange('three', v)"
        controls-position="right"
        :min="item.minValue === '' ? -Infinity : Number(item.minValue)"
        :max="item.maxValue === '' ? Infinity : Number(item.maxValue)"
      >
      </el-input-number>
    </template>
    <el-button style="width: 28%" v-if="hasValueUnit(item)">{{ item.valueUnit[0] }}</el-button>
  </div>
</template>

<script>
export default {
  name: 'properties-multiinput',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: [Object, String],
      default() {
        return { one: '', two: '', three: '' };
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (typeof val !== 'object') {
          this.$emit('change', { one: '', two: '', three: '' });
        }
      },
      deep: true,
    },
    item: {
      handler(v) {
        let units = v.valueUnit.slice(0);
        units = units.filter(u => !!u);
        if (units.length) {
          this.$emit('changeUnits', { [v.idName]: units[0] });
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleChange(key, v) {
      const reValue = {
        ...this.value,
        [key]: v,
      };
      delete reValue['value'];
      reValue['value'] = Object.keys(reValue)
        .map(item => {
          return reValue[item];
        })
        .filter(item => item)
        .join(',');
      this.$emit('change', reValue);
    },
    hasValueUnit(item) {
      if (item.valueUnit) {
        let units = item.valueUnit.slice(0);
        units = units.filter(u => !!u);
        return !!units.length;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.multi-input {
  width: 220px;
  display: flex;
  justify-content: space-between;
}
.three-multi {
  width: 270px;
}
</style>